import { leadConstants } from './constants/leadConstants';

const listLeads = (data: any) => ({
  type: leadConstants.listLeadsRequest,
  payload: data
});

const saveLead = (data: any) => ({
  type: leadConstants.saveLeadRequest,
  payload: data
});

const viewLead = (data: any) => ({
  type: leadConstants.viewLeadRequest,
  payload: data
});

const updateLead = (id: string, data: any) => ({
  type: leadConstants.updateLeadRequest,
  payload: { id, ...data }
});

const deleteLead = (data: any) => ({
  type: leadConstants.deleteLeadRequest,
  payload: data
});

const addFollowUp = (id: string, data: any) => ({
  type: leadConstants.addFollowUpRequest,
  payload: { id, ...data }
});

export const leadActions = {
  listLeads,
  saveLead,
  viewLead,
  updateLead,
  deleteLead,
  addFollowUp
};
